export default __webpack_public_path__ + "static/assets/ae21fb5998a430548e7f53c843e762f2.png";